import {
  Box,
  Flex,
  Heading,
  Button,
  HStack,
  useBreakpointValue,
  IconButton,
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  VStack,
  useDisclosure,
  useColorModeValue,
  Select,
  Link,
} from "@chakra-ui/react";
import { HamburgerIcon } from "@chakra-ui/icons";
import { NavLink, Link as RouterLink } from "react-router-dom";
import { PeerxLogo } from "./icons/Icons";
import { useTranslation } from "react-i18next";

function Header() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const isMobile = useBreakpointValue({ base: true, md: false });
  const accentColor = useColorModeValue("brand.400", "green.300");
  const { t, i18n } = useTranslation();

  // Handle Language Change
  const handleLanguageChange = (event) => {
    i18n.changeLanguage(event.target.value);
  };

  return (
    <Flex justify="space-between" align="center" mb={8}>
      {/* Logo */}
      <Heading size="lg" color={accentColor} fontWeight="bold" letterSpacing="wider" as={RouterLink} to="/">
        <PeerxLogo h="90px" w="160px" />
      </Heading>

      {/* Language Switcher */}
      {/* <Box position="fixed" top="4" right="4" zIndex="120" p={2}>
        <Select
          value={i18n.language}
          onChange={handleLanguageChange}
          width="120px"
          bg="white"
          color="black"
          size="sm"
        >
          <option value="en">English</option>
          <option value="fr">Français</option>
          <option value="es">Español</option>
        </Select>
      </Box> */}

      {/* Desktop Navigation */}
      {!isMobile ? (
        <Box
          border="2px"
          borderColor="green.300"
          borderRadius="full"
          pl={{ base: 20, md: 30, lg: 40 }}
          pr={6}
          py={3}
          boxShadow="lg"
          bg="whiteAlpha.800"
        >
          <HStack spacing={4}>
            <Link  fontSize="lg" color="brand.300" variant="ghost" _hover={{ color: accentColor }} as={RouterLink} to="/">
              {t("header.home_label")}
            </Link>
            <Link href="#features" fontSize="lg" color="brand.300" variant="ghost" _hover={{ color: accentColor }}>
              {t("header.features_label")}
            </Link>
            <Link href="#pricing" fontSize="lg" color="brand.300" variant="ghost" _hover={{ color: accentColor }}>
              {t("header.pricing_label")}
            </Link>
            <Link href="#faq" fontSize="lg" color="brand.300" variant="ghost" _hover={{ color: accentColor }}>
              {t("header.faq_label")}
            </Link>
            <Button fontSize="xl" color="brand.300" variant="ghost" _hover={{ color: accentColor }} as={RouterLink} to="/auth/sign-in">
              {t("header.login_label")}
            </Button>
            <Button fontSize="xl" bg="brand.300" colorScheme="green" borderRadius="full" px={6} as={RouterLink} to="/auth/sign-up">
              {t("header.signup_label")}
            </Button>
          </HStack>
        </Box>
      ) : (
        // Mobile Menu Button
        <IconButton icon={<HamburgerIcon />} aria-label="Open menu" variant="outline" onClick={onOpen} />
      )}

      {/* Mobile Drawer */}
      <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader fontSize="2xl" color="brand.300">{t("header.menu_label")}</DrawerHeader>
          <DrawerBody>
            <VStack spacing={4} align="start">
              <Link fontSize="lg" color="brand.300" variant="ghost" onClick={onClose} _hover={{ color: accentColor }} as={RouterLink} to="/">
                {t("header.home_label")}
              </Link>
              <Link href="#features" fontSize="lg" color="brand.300" variant="ghost" onClick={onClose} _hover={{ color: accentColor }}>
                {t("header.features_label")}
              </Link>
              <Link href="#pricing" fontSize="lg" color="brand.300" variant="ghost" onClick={onClose} _hover={{ color: accentColor }}>
                {t("header.pricing_label")}
              </Link>
              <Link href="#faq" fontSize="lg" color="brand.300" variant="ghost" onClick={onClose} _hover={{ color: accentColor }}>
                {t("header.faq_label")}
              </Link>
              <Button fontSize="xl" color="brand.300" variant="ghost" onClick={onClose} _hover={{ color: accentColor }} as={RouterLink} to="/auth/sign-in">
                {t("header.login_label")}
              </Button>
              <Button fontSize="xl" bg="brand.300" colorScheme="green" borderRadius="full" px={6} onClick={onClose} as={RouterLink} to="/auth/sign-up">
                {t("header.signup_label")}
              </Button>
            </VStack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Flex>
  );
}

export default Header;
